if (window.innerWidth <= 768) {
  jQuery(document).ready(function ($) {
    $('#navtop_bt_resp').on('click', function () {
      $(this).toggleClass('is-open'); // toggle sur le bouton
      $('.is-style-nav').slideToggle(650); // slide toggle sur le menu
    });
  });
}
